import {Payment} from './payment';
import {Contact} from './contact';
import {PaymentMethod} from './paymentmethod';

export class Donation {
  public payment: Payment;

  public contact: Contact;

  constructor() {
    this.payment = new Payment();
    this.contact = new Contact();
  }

  public getIncompleteNavigationStep(maxStepIndex: number): string {
    let navigationStep: string = null;

    console.log('testing getIncompleteNavigationStep() maxStepIndex: ' + maxStepIndex);
    for (let i = 0; i <= maxStepIndex; i++) {
      console.log('testing getIncompleteNavigationStep() i: ' + i);
      if (!this.isComplete(i)) {
        console.log('!isComplete() stepIndex: ' + i);
        if (i === 0) {
          navigationStep = '/';
        } else {
          navigationStep = '/step' + (i + 1);
        }
      }
      break;
    }

    return navigationStep;
  }

  public isCompletedTill(stepIndex: number): boolean {
    for (let i = 0; i <= stepIndex; i++) {
      if (!this.isComplete(i)) {
        return false;
      }
    }

    return true;
  }

  public isComplete(stepIndex: number): boolean {
    let complete = false;

    switch (stepIndex) {
      case 0: // Payment
        complete = this.payment.frequency != null && this.payment.amount != null;
        break;
      case 1: // Name & email
        complete = this.contact.gender != null && this.contact.firstName != null && this.contact.surname != null && this.contact.emailAddress != null;
        break;
      case 2: // Payment Method
        const method = this.payment.method;
        if (method != null) {
          const payment = this.payment;
          switch (method) {
            case PaymentMethod.IDEAL:
              complete = payment.issuerId != null;
              break;
            case PaymentMethod.CREDITCARD:
              complete = payment.cardData.holderName != null && payment.cardData.number != null && payment.cardData.cvc != null && payment.cardData.expiryYear != null && payment.cardData.expiryMonth != null;
              break;
            case PaymentMethod.DIRECTDEBIT:
              complete = payment.bankAccount.iban != null && payment.bankAccount.ownerName != null;
              break;
          }
        } else {
          complete = false;
        }
    }

    console.log('Donation.isComplete(stepIndex: ' + stepIndex + ') = ' + complete);
    return complete;
  }
}
